import { render } from "./GameItemsPreview.vue?vue&type=template&id=15f13ac0&scoped=true&ts=true"
import script from "./GameItemsPreview.vue?vue&type=script&lang=ts"
export * from "./GameItemsPreview.vue?vue&type=script&lang=ts"

import "./GameItemsPreview.vue?vue&type=style&index=0&id=15f13ac0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f13ac0"]])

export default __exports__